import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "confinedOffset11": "main-logged-out-58e5f421-confinedOffset11-WXUgJq",
  "wide10": "main-logged-out-58e5f421-wide10-WXUgJq",
  "confined8": "main-logged-out-58e5f421-confined8-WXUgJq",
  "wide9": "main-logged-out-58e5f421-wide9-WXUgJq",
  "defaultOffset10": "main-logged-out-58e5f421-defaultOffset10-WXUgJq",
  "tiny4": "main-logged-out-58e5f421-tiny4-WXUgJq",
  "default6": "main-logged-out-58e5f421-default6-WXUgJq",
  "tiny8": "main-logged-out-58e5f421-tiny8-WXUgJq",
  "default9": "main-logged-out-58e5f421-default9-WXUgJq",
  "confined1": "main-logged-out-58e5f421-confined1-WXUgJq",
  "confinedOffset0": "main-logged-out-58e5f421-confinedOffset0-WXUgJq",
  "confinedOffset6": "main-logged-out-58e5f421-confinedOffset6-WXUgJq",
  "xwide6": "main-logged-out-58e5f421-xwide6-WXUgJq",
  "xwideOffset7": "main-logged-out-58e5f421-xwideOffset7-WXUgJq",
  "wideGridContainer": "main-logged-out-58e5f421-wideGridContainer-WXUgJq",
  "defaultOffset8": "main-logged-out-58e5f421-defaultOffset8-WXUgJq",
  "wideOffset10": "main-logged-out-58e5f421-wideOffset10-WXUgJq",
  "confinedOffset8": "main-logged-out-58e5f421-confinedOffset8-WXUgJq",
  "wideOffset7": "main-logged-out-58e5f421-wideOffset7-WXUgJq",
  "tinyOffset1": "main-logged-out-58e5f421-tinyOffset1-WXUgJq",
  "wideOffset3": "main-logged-out-58e5f421-wideOffset3-WXUgJq",
  "armstrongGridContainer": "main-logged-out-58e5f421-armstrongGridContainer-WXUgJq",
  "tiny3": "main-logged-out-58e5f421-tiny3-WXUgJq",
  "default2": "main-logged-out-58e5f421-default2-WXUgJq",
  "wide4": "main-logged-out-58e5f421-wide4-WXUgJq",
  "confinedOffset4": "main-logged-out-58e5f421-confinedOffset4-WXUgJq",
  "tinyOffset2": "main-logged-out-58e5f421-tinyOffset2-WXUgJq",
  "tinyOffset5": "main-logged-out-58e5f421-tinyOffset5-WXUgJq",
  "gridContainer": "main-logged-out-58e5f421-gridContainer-WXUgJq",
  "defaultOffset5": "main-logged-out-58e5f421-defaultOffset5-WXUgJq",
  "standardGridContainer": "main-logged-out-58e5f421-standardGridContainer-WXUgJq",
  "wideOffset9": "main-logged-out-58e5f421-wideOffset9-WXUgJq",
  "wide8": "main-logged-out-58e5f421-wide8-WXUgJq",
  "xwide3": "main-logged-out-58e5f421-xwide3-WXUgJq",
  "defaultOffset1": "main-logged-out-58e5f421-defaultOffset1-WXUgJq",
  "xwideOffset8": "main-logged-out-58e5f421-xwideOffset8-WXUgJq",
  "wide0": "main-logged-out-58e5f421-wide0-WXUgJq",
  "confined3": "main-logged-out-58e5f421-confined3-WXUgJq",
  "confined0": "main-logged-out-58e5f421-confined0-WXUgJq",
  "default10": "main-logged-out-58e5f421-default10-WXUgJq",
  "confined10": "main-logged-out-58e5f421-confined10-WXUgJq",
  "tiny9": "main-logged-out-58e5f421-tiny9-WXUgJq",
  "xwideOffset4": "main-logged-out-58e5f421-xwideOffset4-WXUgJq",
  "defaultOffset3": "main-logged-out-58e5f421-defaultOffset3-WXUgJq",
  "wideOffset0": "main-logged-out-58e5f421-wideOffset0-WXUgJq",
  "wideOffset1": "main-logged-out-58e5f421-wideOffset1-WXUgJq",
  "wide12": "main-logged-out-58e5f421-wide12-WXUgJq",
  "xwide5": "main-logged-out-58e5f421-xwide5-WXUgJq",
  "tiny10": "main-logged-out-58e5f421-tiny10-WXUgJq",
  "xwide4": "main-logged-out-58e5f421-xwide4-WXUgJq",
  "default3": "main-logged-out-58e5f421-default3-WXUgJq",
  "wideOffset11": "main-logged-out-58e5f421-wideOffset11-WXUgJq",
  "xwideOffset1": "main-logged-out-58e5f421-xwideOffset1-WXUgJq",
  "xwide1": "main-logged-out-58e5f421-xwide1-WXUgJq",
  "default0": "main-logged-out-58e5f421-default0-WXUgJq",
  "default8": "main-logged-out-58e5f421-default8-WXUgJq",
  "confinedOffset10": "main-logged-out-58e5f421-confinedOffset10-WXUgJq",
  "xwideOffset5": "main-logged-out-58e5f421-xwideOffset5-WXUgJq",
  "row": "main-logged-out-58e5f421-row-WXUgJq",
  "col": "main-logged-out-58e5f421-col-WXUgJq",
  "default1": "main-logged-out-58e5f421-default1-WXUgJq",
  "defaultOffset9": "main-logged-out-58e5f421-defaultOffset9-WXUgJq",
  "tiny0": "main-logged-out-58e5f421-tiny0-WXUgJq",
  "wide6": "main-logged-out-58e5f421-wide6-WXUgJq",
  "xwide12": "main-logged-out-58e5f421-xwide12-WXUgJq",
  "tinyOffset11": "main-logged-out-58e5f421-tinyOffset11-WXUgJq",
  "xwideOffset6": "main-logged-out-58e5f421-xwideOffset6-WXUgJq",
  "default11": "main-logged-out-58e5f421-default11-WXUgJq",
  "xwideOffset11": "main-logged-out-58e5f421-xwideOffset11-WXUgJq",
  "tiny7": "main-logged-out-58e5f421-tiny7-WXUgJq",
  "tiny1": "main-logged-out-58e5f421-tiny1-WXUgJq",
  "tinyOffset3": "main-logged-out-58e5f421-tinyOffset3-WXUgJq",
  "confined5": "main-logged-out-58e5f421-confined5-WXUgJq",
  "xwide2": "main-logged-out-58e5f421-xwide2-WXUgJq",
  "grid": "main-logged-out-58e5f421-grid-WXUgJq",
  "default7": "main-logged-out-58e5f421-default7-WXUgJq",
  "confined2": "main-logged-out-58e5f421-confined2-WXUgJq",
  "wideOffset8": "main-logged-out-58e5f421-wideOffset8-WXUgJq",
  "xwide0": "main-logged-out-58e5f421-xwide0-WXUgJq",
  "default12": "main-logged-out-58e5f421-default12-WXUgJq",
  "confined7": "main-logged-out-58e5f421-confined7-WXUgJq",
  "confinedOffset7": "main-logged-out-58e5f421-confinedOffset7-WXUgJq",
  "xwide11": "main-logged-out-58e5f421-xwide11-WXUgJq",
  "tinyOffset7": "main-logged-out-58e5f421-tinyOffset7-WXUgJq",
  "tiny11": "main-logged-out-58e5f421-tiny11-WXUgJq",
  "default5": "main-logged-out-58e5f421-default5-WXUgJq",
  "confined6": "main-logged-out-58e5f421-confined6-WXUgJq",
  "confined4": "main-logged-out-58e5f421-confined4-WXUgJq",
  "wide7": "main-logged-out-58e5f421-wide7-WXUgJq",
  "xwide9": "main-logged-out-58e5f421-xwide9-WXUgJq",
  "tiny2": "main-logged-out-58e5f421-tiny2-WXUgJq",
  "confinedOffset2": "main-logged-out-58e5f421-confinedOffset2-WXUgJq",
  "xwideOffset2": "main-logged-out-58e5f421-xwideOffset2-WXUgJq",
  "xwideOffset10": "main-logged-out-58e5f421-xwideOffset10-WXUgJq",
  "wideOffset4": "main-logged-out-58e5f421-wideOffset4-WXUgJq",
  "tiny6": "main-logged-out-58e5f421-tiny6-WXUgJq",
  "confined12": "main-logged-out-58e5f421-confined12-WXUgJq",
  "confinedOffset9": "main-logged-out-58e5f421-confinedOffset9-WXUgJq",
  "wideOffset5": "main-logged-out-58e5f421-wideOffset5-WXUgJq",
  "wideOffset6": "main-logged-out-58e5f421-wideOffset6-WXUgJq",
  "xwide8": "main-logged-out-58e5f421-xwide8-WXUgJq",
  "defaultOffset11": "main-logged-out-58e5f421-defaultOffset11-WXUgJq",
  "confinedOffset5": "main-logged-out-58e5f421-confinedOffset5-WXUgJq",
  "defaultOffset6": "main-logged-out-58e5f421-defaultOffset6-WXUgJq",
  "xwide10": "main-logged-out-58e5f421-xwide10-WXUgJq",
  "tinyOffset6": "main-logged-out-58e5f421-tinyOffset6-WXUgJq",
  "confined9": "main-logged-out-58e5f421-confined9-WXUgJq",
  "xwideOffset9": "main-logged-out-58e5f421-xwideOffset9-WXUgJq",
  "wide11": "main-logged-out-58e5f421-wide11-WXUgJq",
  "tinyOffset4": "main-logged-out-58e5f421-tinyOffset4-WXUgJq",
  "defaultOffset4": "main-logged-out-58e5f421-defaultOffset4-WXUgJq",
  "tinyOffset10": "main-logged-out-58e5f421-tinyOffset10-WXUgJq",
  "wide1": "main-logged-out-58e5f421-wide1-WXUgJq",
  "xwideOffset0": "main-logged-out-58e5f421-xwideOffset0-WXUgJq",
  "xwideOffset3": "main-logged-out-58e5f421-xwideOffset3-WXUgJq",
  "tinyOffset9": "main-logged-out-58e5f421-tinyOffset9-WXUgJq",
  "tiny5": "main-logged-out-58e5f421-tiny5-WXUgJq",
  "tinyOffset0": "main-logged-out-58e5f421-tinyOffset0-WXUgJq",
  "wide3": "main-logged-out-58e5f421-wide3-WXUgJq",
  "confinedOffset1": "main-logged-out-58e5f421-confinedOffset1-WXUgJq",
  "wideOffset2": "main-logged-out-58e5f421-wideOffset2-WXUgJq",
  "confined11": "main-logged-out-58e5f421-confined11-WXUgJq",
  "default4": "main-logged-out-58e5f421-default4-WXUgJq",
  "xwide7": "main-logged-out-58e5f421-xwide7-WXUgJq",
  "defaultOffset2": "main-logged-out-58e5f421-defaultOffset2-WXUgJq",
  "tiny12": "main-logged-out-58e5f421-tiny12-WXUgJq",
  "confinedOffset3": "main-logged-out-58e5f421-confinedOffset3-WXUgJq",
  "defaultOffset7": "main-logged-out-58e5f421-defaultOffset7-WXUgJq",
  "tinyOffset8": "main-logged-out-58e5f421-tinyOffset8-WXUgJq",
  "wide2": "main-logged-out-58e5f421-wide2-WXUgJq",
  "wide5": "main-logged-out-58e5f421-wide5-WXUgJq"
};